import { Binder } from '@ribajs/core'
import { CustomerFavoritesService } from '../services/index.js'
import { CustomerFavorite } from '../types/index.js'

/**
 * Sets the shopify items count
 */
export class CustomerFavoritesCountBinder extends Binder<void, HTMLElement> {
  static key = 'customer-favorites-count'

  private onChanged(
    changedFavorite: CustomerFavorite,
    favorites: CustomerFavorite[],
  ) {
    if (window.debug)
      console.debug('CustomerFavoritesCountBinder.onChanged', favorites)
    this.setCount(favorites.length)
  }

  private setCount(count: number) {
    if (!count) {
      this.el.textContent = ''
      if (this.el.parentElement) {
        this.el.parentElement.style.display = 'none'
      }
      return
    }
    if (this.el.parentElement) {
      this.el.parentElement.style.display = ''
    }
    this.el.textContent = String(count)
  }

  async routine() {
    CustomerFavoritesService.events.off(
      CustomerFavoritesService.changedEventName,
      this.onChanged,
      this,
    )
    CustomerFavoritesService.events.on(
      CustomerFavoritesService.changedEventName,
      this.onChanged,
      this,
    )
    this.setCount(await CustomerFavoritesService.count())
  }

  async bind() {
    CustomerFavoritesService.events.on(
      CustomerFavoritesService.changedEventName,
      this.onChanged,
      this,
    )
    this.setCount(await CustomerFavoritesService.count())
  }

  unbind() {
    CustomerFavoritesService.events.off(
      CustomerFavoritesService.changedEventName,
      this.onChanged,
      this,
    )
  }
}
